if (!customElements.get('lets-get-real-video')) {
  customElements.define('lets-get-real-video', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (this.controller || !this.isConnected) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.run = this.querySelector('.lgr-video__run');
      this.button = this.querySelector('.lgr-video__play');
      this.player = this.querySelector('.lgr-video__player');
      this.classList.add('is-ready');
      this.tick = () => {
        if (this.pending) return;
        this.pending = true;
        this.frame = requestAnimationFrame(() => { this.pending = false; this.update(); });
      };
      window.addEventListener('scroll',this.tick,{...options,passive:true});
      window.addEventListener('resize',this.tick,options);
      this.motion.addEventListener('change',this.tick,options);
      this.button?.addEventListener('click',() => this.play(),options);
      this.querySelector('.lgr-video__poster')?.addEventListener('click',() => {
        if (this.button) this.play();
      },options);
      // Keep the pinned frame below the theme's actual sticky header.
      this.header=document.querySelector('#hd, sticky-header');
      if (this.header) {
        this.headerObserver=new ResizeObserver(() => {
          this.style.setProperty('--hd',`${this.header.getBoundingClientRect().height}px`);
          this.tick();
        });
        this.headerObserver.observe(this.header);
      }
      document.addEventListener('click', event => {
        const link=event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url=new URL(link.href,location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !this.matchesHash(url.hash)) return;
        event.preventDefault();
        history.pushState(null,'',url.hash);
        this.revealAndScroll();
      },options);
      window.addEventListener('hashchange',() => {
        if (this.matchesHash(location.hash)) this.revealAndScroll();
      },options);
      this.update();
      if (this.matchesHash(location.hash)) this.revealAndScroll();
    }
    matchesHash(hash) {
      if (!this.id || !hash) return false;
      try { return decodeURIComponent(hash.slice(1)) === this.id; }
      catch { return false; }
    }
    revealAndScroll() {
      // Anchor navigation shows the full-width frame throughout the journey.
      // Keep this state after arrival so focus changes cannot restore the inset.
      this.classList.add('is-anchor-revealed');
      // A section's top is only the beginning of its scrub animation.
      // Land inside the pinned runway after the frame and caption are revealed.
      this.mobileSeen=true;
      this.revealStart=performance.now()-1800;
      const top=this.getBoundingClientRect().top+scrollY;
      const header=parseFloat(getComputedStyle(this).getPropertyValue('--hd'));
      const run=this.run.offsetHeight;
      scrollTo({top:Math.max(0,top+(run ? run*.8 : -header)),behavior:this.motion.matches?'auto':'smooth'});
      this.button?.focus({preventScroll:true});
      this.tick();
    }
    update() {
      if (this.classList.contains('is-playing')) return;
      const rect=this.getBoundingClientRect(), run=this.run.offsetHeight;
      const clamp=n=>Math.min(1,Math.max(0,n));
      if (this.motion.matches) this.style.setProperty('--f',1);
      else if (run) this.style.setProperty('--f',clamp((innerHeight*.55-rect.top)/(innerHeight*.55+run*.7)));
      else {
        if (rect.top < innerHeight*.88 && rect.bottom>0) this.mobileSeen=true;
        if (this.mobileSeen && !this.revealStart) this.revealStart=performance.now();
        const elapsed=this.revealStart ? clamp((performance.now()-this.revealStart)/1800) : 0;
        const progress=1-Math.pow(1-elapsed,4);
        this.style.setProperty('--f',progress);
        if (this.mobileSeen && progress<1) this.tick();
      }
    }
    play() {
      if (this.classList.contains('is-playing')) return;
      const content=this.querySelector('template').content.cloneNode(true);
      if (!content.querySelector('video,iframe')) return;
      this.player.replaceChildren(content);
      this.player.hidden=false;
      this.classList.add('is-playing');
      const media=this.player.querySelector('video,iframe');
      media.focus({preventScroll:true});
      if (media.tagName==='VIDEO') {
        const promise=media.play();
        // Native controls remain available when the browser rejects autoplay.
        promise?.catch(() => {});
      }
      const top=this.getBoundingClientRect().top+scrollY;
      const header=parseFloat(getComputedStyle(this).getPropertyValue('--hd'));
      scrollTo({top:Math.max(0,top+(this.run.offsetHeight ? this.run.offsetHeight*.8 : -header)),behavior:this.motion.matches?'auto':'smooth'});
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.pending=false;
      this.controller?.abort(); this.controller=null;
      this.headerObserver?.disconnect();
      this.player?.querySelector('video')?.pause();
      this.player?.replaceChildren();
      if (this.player) this.player.hidden=true;
      this.classList.remove('is-ready','is-playing','is-anchor-revealed');
      this.style.removeProperty('--f');
      this.mobileSeen=false; this.revealStart=null;
    }
  });
}
